import clone from 'lodash-es/clone';
import { isMonarchMultipleAccountsEnabled } from 'owa-account-source-list/lib/flights';
import { createLazyOrchestrator } from 'owa-bundling';
import { default as onSelectedAccountChanged } from 'owa-mail-account-store/lib/actions/onSelectedAccountChanged';
import { mutatorAction } from 'satcheljs';
import type { SignatureStore } from '../store/schema/SignatureStore';
import { store } from '../store/signatureStore';
import getDefaultSignatureStore from '../utils/getDefaultSignatureStore';
import loadSignature from '../utils/loadSignature';

// Cache the store in a map when an account selection is changed. This is to avoid service calls to
// retrieve the signature data when switching back to a previously selected account.
const signatureStoreCache = new Map<string, SignatureStore>();
export const resetSignatureStoreOrchestrator = createLazyOrchestrator(
    onSelectedAccountChanged,
    'clone_onSelectedAccountChanged',
    actionMessage => {
        if (!isMonarchMultipleAccountsEnabled()) {
            throw new Error(
                `Reset Signature store for account selection change is called when multi accounts is turned off. ${actionMessage.selectedEmailAddress}`
            );
        }

        // Clone the current store to save in the cache, this is to avoid a service call when switched to this account in the future.
        const currentStore = clone(store);
        signatureStoreCache.set(actionMessage.oldSourceId, currentStore);

        // Check if the newly selected account store is available in the cache.
        // If available reset the properties of the current store with the new store.
        const newStore = signatureStoreCache.get(actionMessage.selectedAccountSourceId);
        if (newStore) {
            resetStoreForAccountSelectionChange(newStore);
        } else {
            // When the store is not available in the cache, we need to reset the current store with default values first.
            // This is to allow the service call(if made) to do it's work of populating the store without any remnants of the previous store
            resetStoreForAccountSelectionChange(getDefaultSignatureStore());

            // Make appropriate service call to load the signature for the newly selected account
            loadSignature(actionMessage.selectedAccountSourceId);
        }
    }
);

const resetStoreForAccountSelectionChange = mutatorAction(
    'resetStoreForAccountSelectionChange',
    (newStore: SignatureStore) => {
        store.legacySignature = newStore.legacySignature;
        store.roamingSignatureMap = newStore.roamingSignatureMap;
        store.defaultSignatureName = newStore.defaultSignatureName;
        store.defaultReplySignatureName = newStore.defaultReplySignatureName;
    }
);
